// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"UploadAsset_closeButton__1_VUP"};